import React, { useEffect } from 'react'
import event6 from './eventImg/event-13.webp'


const Event5 = () => {
    useEffect(() => {
        document.title = "Net efficiency Impact on central Air-conditioning Systems with use of VFDS on cooling towers";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>13 May 2025</h1>
<h3 className='text-center'>Net efficiency Impact on central Air-conditioning Systems with use of VFDS on cooling towers </h3>
</div>
   <div className='container' id='calanderevent'>
<img src={event6} alt='Net efficiency Impact on central Air-conditioning Systems with use of VFDS on cooling towers'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/Q9xggLkEk1g=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event5

